<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);


  const data = listData.value;
  let name = listData.name
  const textStyle = { "color": "#fff", "fontSize": 26 }
  let getSymbolData = (name) => {
    let arr = [];
    for (var i = 0; i < data.length; i++) {
      arr.push({
        value: data[i],
        symbolPosition: 'end'
      })
    }
    console.log(arr)
    return arr;
  }

  const option= {
    grid: {
      top: '5%',
      left: '3%',
      right: '8%',
      bottom: '0%',
      containLabel: true,
    },
    tooltip: {
      show: false,
    },
    legend: {
      show: false
    },
    xAxis: [
      {
        // max: 100,
        type: 'value',
        show: true,
        splitNumber:3,
        splitLine: {
          show: true,
          lineStyle: {
            type: 'solid',
            color: '#104848',
            width: 1
          }
        },
        axisLabel: {
          show: true,
          interval: 0, //横轴信息全部显示
          textStyle: {
            color: 'rgba(255,255,255,.5)', // 更改坐标轴文字颜色
            fontSize:24 // 更改坐标轴文字大小
          },
          formatter: function(value) {
            // 当值为 0 时不显示标签
            return value + '%'
          }
        },
      }
    ],
    yAxis: [
      {
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        type: 'category',
        axisTick: {
          show: false
        },
        inverse: true,
        data: name,
        axisLabel: {
          interval:0,
          textStyle: textStyle,
          margin: 20
        }
      },
      // {
      //   type: 'category',
      //   inverse: true,
      //   axisTick: 'none',
      //   axisLine: 'none',
      //   show: true,
      //   axisLabel: {
      //     margin: 20,
      //     textStyle: textStyle,
      //     formatter: function (value) {
      //       return value + '元/斤';
      //     }
      //   },
      //   data: data
      // }
    ],
    series: [
      {
        name: '',
        type: 'bar',
        barWidth: 20, // 柱子宽度
        MaxSize: 0,
        showBackground: false,
        yAxisIndex: 0,
        label: {
          show: true,
          position:"right",
          textStyle:{
            color:"#105E4E",
            fontSize:26,
            padding:[0,0,0,20]
          },
        },
        itemStyle: {
          // barBorderRadius: [50, 50, 50, 50],
          color: "#19CC75"
        },
        data: data
      },
      {
        name: '',
        type: 'pictorialBar',
        // symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAAHzmbSZAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAD6ADAAQAAAABAAAAEgAAAACfRog6AAABhUlEQVQ4EZVTv0vDUBC+V1xERASRJm0VCuKmSycXBwcXF/8DBxcXBSFpR2fdHFwcXJwcXFwcHFycTCo6FUQQlBYriJRqwZp33qW9R0KNtTe8u/u+++79uARyZbcAZClebM89DAMEXGegY5bnIEdKAmCVSYgJRVxiQApqDIhxRXrudm8kCsBru96MAZxID9OUQdvbmVC87bfGawVqv1rY3WIiakZB59+0fEdHSY5NQUhg50Z5rzgmhfGCLtoC/W777nGY2p7zad8UF0QR9Sl6pmEM9FUUlNi0tjz3QUDxhgTAfKbsLgnBPkICaI0XiSQTNMQnKYgpGaSHyWZ8Z4XjHpJBjXCWSDJBz/piBsGAUuo+NZmef85ttzjvZ7FtEXEmqNc+smVnsZ+Q+Zg4FNAQAw2XNJaDfg16xV0FjW2D7vU4W3FHk5okirunmG40sWH5xeXfGvwtFgXqc9t3jiQV/z8xVSPCGk2/OnVXGh9YzAL6Oqz2V/Bm+aVVzod4GdgwOKW/5eQHX96Jhf3tNC4AAAAASUVORK5CYII=',
        symbol:'image://https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/nyhongshu/bar.png',
        symbolSize: [15, 20],
        symbolOffset: [13, 0,0,0],
        z: 12,
        // itemStyle: {
        //   normal: {
        //     color: '#fff'
        //   }
        // },
        data: getSymbolData(data)
      }
    ]

  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
